'use es6';

import I18n from 'I18n';
import * as Industries from '../constants/reviews/Industry';
import * as CompanySizes from '../constants/reviews/CompanySize';
import Review from '../records/Review';
export const getIndustryOptions = () => Object.values(Industries).map(industry => {
  return {
    text: I18n.text(`ecosystemMarketplaceCore.reviews.industry.${industry}`),
    value: industry
  };
}).sort((a, b) => {
  return a.value === Industries.PREFER_NOT_TO_SAY || b.text < a.text ? 1 : -1;
});
export const getEmployeesOptions = () => Object.values(CompanySizes).map(range => {
  return {
    text: Review.toEmployeeString(range),
    value: range
  };
});